import { defaultsDeep } from 'lodash';

const defaultOptions = () => ({
  headings: {
    opaAccountNumber: "OPA #",
    opaAddress: "Address",
    numberOfUnits: "# units",
    submittedAt: "Submitted at",
    certificationStatus: 'Status',
    propertyType: 'Type',
    actions: 'Actions',
  },
  columnsClasses: {
    opaAccountNumber: 'nowrap',
    actions: 'has-text-centered actions p-sm',
    status: 'is-status nowrap has-text-centered',
    certificationStatus: 'is-status nowrap has-text-centered',
    propertyType: 'has-text-centered',
    numberOfUnits: 'nowrap has-text-centered',
    report: 'is-report nowrap',
  },
  sortIcon: {
    base: "fa fas",
    is: "fa-sort",
    up: "fa-sort-up",
    down: "fa-sort-down",
  },
  debounce: 250,
  perPage: 50,
  perPageValues: [],
  orderBy: {
  },
  dateColumns: [
    'submittedAt',
  ],
  dateFormat: "MM/DD/YYYY h:mm A",
  pagination: {
    chunk: 10,
  },
  sortable: [],
  filterable: [],
  texts: {
    filter: "Search table:",
    filterPlaceholder: "Search...",
  },
  skin: 'VueTables__table table is-middle is-bordered is-striped is-hoverable is-fullwidth fixed',
});

export const options = function (options) {
  return defaultsDeep({}, options, defaultOptions());
};
